




















































import Vue from "vue"
import { required, email } from "vuelidate/lib/validators"
import FacebookAuthButton from "~/components/custom/login/FacebookAuthButton.vue"
import GoogleAuthButton from "~/components/custom/login/GoogleAuthButton.vue"
import BoundaryLine from "~/components/guideline/util/BoundaryLine.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import FormInputField from "~/components/guideline/form/field/InputField.vue"
import FormWrapper from "~/components/guideline/form/FormWrapper.vue"
import { BackendApi } from "~/backendApis"

export default Vue.extend({
  components: {
    FacebookAuthButton,
    GoogleAuthButton,
    BoundaryLine,
    ConversionButton,
    FormInputField,
    FormWrapper,
  },
  data() {
    return {
      email: "",
      isLoading: false,
      errorMessage: "",
    }
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  computed: {
    emailError() {
      if (this.$v.email.$error) {
        if (!this.$v.email.required) {
          return "メールアドレスは必須項目です。"
        }
        if (!this.$v.email.email) {
          return "メールアドレスの形式が不正です。"
        }
      }
      return ""
    },
  },
  methods: {
    async signupEmail() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isLoading = true
      const methods = await this.$clAuth.fetchSignInMethods(this.email)
      if (methods.length > 0) {
        this.errorMessage = "このメールアドレスはご利用になれません。"
        this.isLoading = false
        return
      }
      await BackendApi.general.userAccount.write.createTemporaryAccount({
        email: this.email,
      })
      this.$nuxt.$router.push({ path: "/signup/confirm_email" })
    },
    signupFacebook(): void {
      this.$clAuth.loginFacebook()
    },
    signupGoogle(): void {
      this.$clAuth.loginGoogle()
    },
  },
})
